class FomoBanner extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });
    this._listeners = [];      
    this._animationFrame = null; 
  }

  async connectedCallback() {
    if (this.dataset.enabled !== "true") return;

    const coupon = this.dataset.coupon || "";
    const appliedCoupon = localStorage.getItem("applied_coupon");
    if (appliedCoupon && appliedCoupon === coupon) {
      this.remove();
      return;
    }

    const text = this.dataset.text || "⚡ אל תפספסו! המבצע מסתיים בעוד:";
    const endDate = this.dataset.endDate || "";
    const bg = this.dataset.bg || "#ffe9e9";
    const color = this.dataset.color || "#000";

    const style = `
      <style>
        :host {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 1em;
          background: ${bg};
          color: ${color};
          text-align: center;
          padding: 1rem;
          border-radius: 8px;
          margin: 1em;
          box-shadow: 0 1px 4px rgba(0,0,0,0.1);
          transition: opacity 0.4s ease, transform 0.4s ease;
          opacity: 1;
          transform: translateY(0);
        }
        :host(.hide) {
          opacity: 0;
          transform: translateY(-10px);
          pointer-events: none;
        }
        .fomo-text { font-size: 1.1rem; }
        .fomo-timer { font-weight: 600; font-size: 1.25rem; letter-spacing: 1px; }
        p { padding: 0; margin: 0; }

        .fomo-coupon span {
          background: #000;
          color: #fff;
          padding: 0.4rem 0.8rem;
          border-radius: 4px;
          font-size: 0.9rem;
          cursor: pointer;
          user-select: none;
          transition: background 0.2s ease;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .fomo-coupon span:hover { background: #333; }
        .fomo-coupon span.copied { background: #4caf50 !important; color: #fff; }

        @media (max-width: 767.98px) {
          :host { font-size: .5em; flex-wrap: wrap; gap: 0.6em; margin: 1em; padding: .5rem; }
          .fomo-text { font-size: .8rem; font-weight: 700; }
          .fomo-coupon span {
            margin-right: 2em;
            width: 4em;
            padding: 0.2rem 1rem;
            font-size: 0.7rem;
            border-radius: 6px;
            font-weight: 700;
          }
          .fomo-timer{ font-size: 1rem; letter-spacing: 0px; }
        }
      </style>
    `;

    const markup = `
      <div class="fomo-text">${text}</div>
      ${
        coupon
          ? `<div class="fomo-coupon">
               <span id="copyCoupon" title="העתק קוד">${coupon}</span>
             </div>`
          : ""
      }
      <div class="fomo-timer" id="timer"></div>
    `;

    this.shadowRoot.innerHTML = style + markup;

    if (endDate) this.startCountdown(endDate);
    if (coupon) this.enableCouponCopy(coupon);
  }

  // ===== COUNTDOWN =====
  startCountdown(endDate) {
    const timerEl = this.shadowRoot.querySelector("#timer");
    const endTime = new Date(endDate.replace(" ", "T")).getTime();
    if (isNaN(endTime)) {
      timerEl.textContent = "תאריך לא תקין";
      return;
    }

    const update = () => {
      const diff = endTime - Date.now();
      if (diff <= 0) {
        timerEl.textContent = "הסתיים!";
        this._animationFrame = null;
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      timerEl.textContent =
        (days > 0 ? `${days} ימים ` : "") +
        `${hours.toString().padStart(2, "0")}:${minutes
          .toString()
          .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

      this._animationFrame = requestAnimationFrame(update);
    };

    update();
  }

  // ===== COUPON COPY =====
  async enableCouponCopy(coupon) {
    const couponEl = this.shadowRoot.querySelector("#copyCoupon");
    if (!couponEl) return;

    const handler = async () => {
      try {
        await navigator.clipboard.writeText(coupon);
        couponEl.classList.add("copied");
        couponEl.textContent = "הועתק!";

        const res = await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            attributes: { discount_code: coupon },
          }),
        });
        const cartData = await res.json();

        await fetch(`/discount/${encodeURIComponent(coupon)}`, {
          method: "GET",
          headers: { Accept: "application/json" },
        });

        if (window.CartManagerInstance) {
          const cartManager = window.CartManagerInstance;
          await cartManager.renderMiniCart({ keepOpen: true });
          await cartManager.updateCartIconBubble(cartData);
        }

        localStorage.setItem("applied_coupon", coupon);

        setTimeout(() => {
          this.classList.add("hide");
          setTimeout(() => this.remove(), 400);
        }, 1000);
      } catch (err) {
        console.error("[FomoBanner] Copy or apply failed:", err);
      }
    };

    couponEl.addEventListener("click", handler);
    this._listeners.push({ element: couponEl, event: "click", handler });
  }

  // ===== CLEANUP =====
  disconnectedCallback() {
    this._listeners.forEach(({ element, event, handler }) => {
      element.removeEventListener(event, handler);
    });
    this._listeners = [];

    if (this._animationFrame) {
      cancelAnimationFrame(this._animationFrame);
      this._animationFrame = null;
    }
  }
}

customElements.define("fomo-banner", FomoBanner);
